import { getImage, GatsbyImage } from "gatsby-plugin-image";
import AccessCard from "../../../../src/components/blogparts/accesscard";
import TwoFlexImg from "../../../../src/components/blogparts/twofleximg";
import Balloon from "../../../../src/components/blogparts/balloon";
import ArticleFooter from "../../../../src/components/blogparts/articlefooter";
import * as styles from "../../../../src/styles/basemdx.module.scss";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  AccessCard,
  TwoFlexImg,
  Balloon,
  ArticleFooter,
  styles,
  React
};